module.exports = __webpack_public_path__ + "static/media/tela_bemvindo.cf5dc82e.png";